<template>
  <div>
    <viewTable
      ref="viewTable"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      :table-select="false"
      url="productionManage/storeIssue"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="$refs.viewTable.loadData(1)">
          <el-form-item label="生产中心">
            <el-input v-model="filter.workCenterName" class="workCenterInput" placeholder="请选择生产中心" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.workCenterSelect.open()" />
            </el-input>
          </el-form-item>
          <el-form-item label="发料状态">
            <el-select v-model="filter.feedingStatus" placeholder="请选择发料状态" clearable>
              <el-option label="待发料" :value="10" />
              <el-option label="发料中" :value="20" />
              <el-option label="已发料" :value="80" />
            </el-select>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable />
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable />
          </el-form-item>
          <el-form-item label="工单编号">
            <el-input v-model.trim="filter.productionOrderNo" placeholder="请输入工单编号" clearable />
          </el-form-item>
          <el-form-item label="派工单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入派工单号" clearable />
          </el-form-item>
          <el-form-item label="工单类型">
            <el-select v-model="filter.productionOrderType" placeholder="请选择工单类型" clearable>
              <el-option label="销售订单" :value="1" />
              <el-option label="自制工单" :value="2" />
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button type="primary" v-if="limits.seedAuth" @click="storeIssueHandle(scope.row)">发料</el-button>
        <el-button type="primary" v-if="limits.printAuth" disabled @click="printHandle(scope.row.pkid)">打印</el-button>
      </template>
    </viewTable>
    <!-- 工单发料 -->
    <add-store-issue ref="addStoreIssue" @save-success="loadData(1)" />
    <!-- 生产中心选择 -->
    <work-center-select ref="workCenterSelect" @select="workCenterSelect" />
    <!-- 发料记录 -->
    <stroe-issue-records ref="stroeIssueRecords" />
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import AddStoreIssue from "./AddStoreIssue";
import StroeIssueRecords from "./StroeIssueRecords";
import WorkCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
export default {
  components: { viewTable, AddStoreIssue, WorkCenterSelect, StroeIssueRecords },
  data() {
    return {
      limits: {
        printAuth: this.$auth(320),
        seedAuth: this.$auth(319),
      },
      filter: {
        workCenterName: "",
        feedingStatus: "",
        materialNo: "",
        materialName: "",
        billNo: "",
        productionOrderNo: "",
        productionOrderType: "",
      },
      columnsProperty: [
        {
          tooltip: true,
          key: "billNo",
          width: 130,
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  color: "#2d8cf0",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.$refs.stroeIssueRecords.open(params.row.billNo);
                  },
                },
              },
              params.row.billNo
            );
          },
        },
        {
          tooltip: true,
          key: "statusName",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "feedingStatusName",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "verificationStatusName",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "productionOrderNo",
          width: 140,
          align: "center",
        },
        {
          tooltip: true,
          key: "prodOrderTypeName",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialNo",
          width: 110,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialName",
          minWidth: 300,
        },
        {
          tooltip: true,
          key: "specification",
          width: 240,
        },
        {
          tooltip: true,
          key: "warehousingQuantity",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "routingName",
          width: 120,
        },
        {
          tooltip: true,
          key: "materialHeight",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialWidth",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialLength",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialWeight",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "unitName",
          width: 80,
          align: "center",
        },
        {
          tooltip: true,
          key: "workCenterName",
          width: 120,
        },
        {
          tooltip: true,
          key: "quantity",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "outputQuantity",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "planStartTime",
          width: 160,
          align: "center",
        },
        {
          tooltip: true,
          key: "planFinishTime",
          width: 160,
          align: "center",
        },
        {
          tooltip: true,
          key: "salesOrderNo",
          width: 130,
          align: "center",
        },
        {
          tooltip: true,
          key: "customerContractNo",
          width: 130,
          align: "center",
        },
        {
          tooltip: true,
          key: "customerName",
          width: 200,
        },
        {
          tooltip: true,
          key: "projectName",
          width: 200,
        },
        {
          tooltip: true,
          key: "deliveryDate",
          width: 120,
          align: "center",
        },
        {
          tooltip: true,
          key: "salesOrderMaterialNote",
          width: 200,
        },
        {
          key: "action",
          align: "center",
          width: 135,
          slot: "action",
          fixed: "right",
        },
      ],
    };
  },

  methods: {
    // 查询派工单列表
    loadData(pageNum) {
      this.selection = [];
      this.$refs.viewTable.loadData(pageNum);
    },

    // 选择生产中心
    workCenterSelect(row) {
      this.filter.workCenterName = row.workCenterName;
    },

    // 发料单打印
    printHandle(pkid) {
      const routeUrl = this.$router.resolve({
        path: "/storeIssuePrint",
        query: {
          params: pkid,
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },

    // 发料
    storeIssueHandle(row) {
      if ([10, 80].includes(row.status)) {
        this.$confirm(`该工单处于${row.statusName}状态`, "错误", {
          type: "error",
          showCancelButton: false,
        });
        return;
      }
      if (row.feedingStatus === 80) {
        this.$confirm("该工单已发料", "错误", {
          type: "error",
          showCancelButton: false,
        });
        return;
      }
      this.$refs.addStoreIssue.open(row.pkid);
    },
  },
};
</script>

<style>
.workCenterInput .el-input__inner {
  width: 135px !important;
}
</style>
